export enum TableName {
  ManagePersonalTasks = "ManagePersonalTasksTable",
  Runs = "RunsTable",
  Dashboard = "DashboardTable",
  IncomingSampleCollections = "IncomingSampleCollectionsTable",
  IncomingSampleTasks = "IncomingSampleTasksTable",
  Tickets = "TicketsTable",
  UserManagerTable = "UserManagerTable",
  Samples = "Sample",
}
